import { render, staticRenderFns } from "./BCXSearchSelect.vue?vue&type=template&id=9787cea2&scoped=true"
import script from "./BCXSearchSelect.vue?vue&type=script&lang=ts"
export * from "./BCXSearchSelect.vue?vue&type=script&lang=ts"
import style0 from "./BCXSearchSelect.vue?vue&type=style&index=0&id=9787cea2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9787cea2",
  null
  
)

export default component.exports